export default __webpack_public_path__ + "static/media/btdg_small_icon.3ff18593.png";